module.exports = __webpack_public_path__ + "media/images/riders/NINO_SCHURTER-a0431527b8f439f807b172cd6253b705.png";